<template>
  <div>
    <table id="datatable-comparing">
      <thead>
        <tr>
          <th style="width: 26%;">รายการ</th>
          <th style="width: 37%;">ข้อมูลเดิม (MSO-Logbook)</th>
          <th style="width: 37%;">ข้อมูลจากระบบ CSG</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="info in infoToBeCompareCSG" :key="info.field">
  <td class="label p-2">
    <span v-html="info.label"></span>:
  </td>
          <!-- <td class="rounded bg-gray-300 p-2" v-if="info.text == info.csg_text"> -->
          <td class="rounded bg-gray-300 p-2">
            {{ info.text }}
          </td>
          <!-- <td class="rounded bg-[#dd9090] p-2" v-else>
            {{ info.text }}
          </td> -->
          <!-- <td class="rounded bg-[#f32b8e] p-2" v-if="info.text == info.csg_text"> -->
          <td class="rounded bg-gray-300 p-2" v-if="info.text == info.csg_text">
            {{ info.csg_text }}
          </td>
          <td class="rounded bg-[#dfaacc] p-2" v-else>
            {{ info.csg_text }}
          </td>
        </tr>
        <tr>
          <td class="label p-2"></td>
          <td>
            <!-- <div class="col-span-12 flex items-center justify-end">
              ถูกบันทึกลงระบบ MSO Logbook โดยอัตโนมัติ
            </div> -->
            <span class="text-red"> *</span> <span style="color: darkgrey;">ถูกบันทึกลงระบบ MSO Logbook โดยอัตโนมัติ</span>
          </td>
          <td style="justify-items: center;">
            <div class="col-span-12 flex items-center justify-end">
              <button
                class="btn btn-primary"
                @click="selectConnectModalForm"
                data-dismiss="modal"
              >
                เลือกใช้ข้อมูลจาก CSG
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <hr class="col-span-12 mt-4" />
  </div>
</template>

<script setup>
import { computed, ref, onMounted, inject, nextTick } from "vue";
import { useStore } from "vuex";
import axios from "axios";
import Swal from "sweetalert2";
const store = useStore();
const generateLogoHTML = ref("");
const cancelData = ref(false);
const openModalStatus = ref(false);
const connect_name = ref("CSG");
const img_connect_logo = ref("");
const props = defineProps({
  // eslint-disable-next-line vue/require-default-prop
  csg_data:Object,
  infoToBeCompareCSG: Array,
  infoData: Object,
});
const emit = defineEmits(['close-modal','update-state']);
const refreshMemberData = inject('refreshMemberData', null);
const swalCustom = Swal.mixin({
  customClass: {
    confirmButton: "btn btn-primary m-1",
    cancelButton: "btn btn-outline-secondary m-1",
  },
  buttonsStyling: false,
});

const selectConnectModalForm = async () => {
   const token = store.getters["userAuth/getToken"];
  
  swalCustom.fire({
    html: "ยืนยันบันทึกข้อมูลจาก ระบบเงินอุดหนุนเพื่อการเลี้ยงดูเด็กแรกเกิด (CSG)",
    icon: "info",
    showCancelButton: true,
    reverseButtons: true,
    confirmButtonText: 'ตกลง',
    cancelButtonText: 'ยกเลิก',
    allowOutsideClick: false,
    allowEscapeKey: true,
  }).then(async (result) => {
    if (result.isConfirmed) {
      try {

       const updates_father = {
          national_id: props.csg_data?.EQ_FATHER_IDCARD || '', 
          title: props.csg_data?.EQ_CODE_FATHER_PRENAME || '', 
          name: props.csg_data?.EQ_FATHER_NAME, 
          surname: props.csg_data?.EQ_FATHER_LNAME,
          nationality: props.csg_data?.EQ_FATHER_NATIONALITY ? props.csg_data?.EQ_FATHER_NATIONALITY.replace('สัญชาติ','') : '',
        };

        let updatedFather = {
          ...(props.infoData?.father || {}), 
          ...updates_father 
        };

        const updates_mother = {
          national_id: props.csg_data?.EQ_MOTHER_IDCARD || '', 
          title: (props.csg_data?.EQ_CODE_MOTHER_PRENAME || '').replace('น.ส.','นางสาว'), 
          name: props.csg_data?.EQ_MOTHER_NAME, 
          surname: props.csg_data?.EQ_MOTHER_LNAME,
          nationality: props.csg_data?.EQ_MOTHER_NATIONALITY ? props.csg_data?.EQ_MOTHER_NATIONALITY.replace('สัญชาติ','') : '',
        };
        
        let updatedMother = {
          ...(props.infoData?.mother || {}), 
          ...updates_mother 
        };

        let update_data = {
          "title": (props.csg_data?.EQC_CODE_PRENAME || '').replace('น.ส.','นางสาว'),
          "name": props.csg_data?.EQC_FIRSTNAME || '',
          "surname": props.csg_data?.EQC_LASTNAME || '',
          "birthdate": convertThaiDateToISO(props.csg_data?.EQC_BIRTH_DATE) || '',
          "father": updatedFather,
          "mother": updatedMother,
          "csg":{"register_status":props.csg_data?.STATUS || '',
          "status": props.csg_data?.csg?.status|| '',
          "registrant_type": props.csg_data?.EQ_REGISTER_TYPE || ''
          }
        };

 let updatedParent = null;
        if(props.csg_data?.EQ_REGISTER_TYPE === "ผู้ปกครอง"){
          let updates_parent = {
          national_id: props.csg_data?.EQ_IDCARD || '', 
          title: (props.csg_data?.EQ_CODE_PRENAME || '').replace('น.ส.','นางสาว'), 
          name: props.csg_data?.EQ_FIRSTNAME || '', 
          surname: props.csg_data?.EQ_LASTNAME || '',
          nationality: props.csg_data?.EQ_NATIONALITY ? props.csg_data?.EQ_NATIONALITY.replace('สัญชาติ','') : '',
          birthdate: convertThaiDateToISO(props.csg_data?.EQ_BIRTHDAY) || ''
        };
        updatedParent = {
          ...(props.infoData?.parent || {}), 
          ...updates_parent 
        };
        update_data.parent = updatedParent;
        }
console.log(update_data)
        const config = {
          url: `${process.env.VUE_APP_BASE_API}member/${props.infoData._id}`,
          method: "PUT",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": `application/json; charset=utf-8`,
          },
          data: {
            update: update_data
          }
        };

        const res = await axios(config);
      
        if (res.status === 200 || res.status === 201) {
           if (refreshMemberData) {
    await refreshMemberData();
  }

  await new Promise(resolve => setTimeout(resolve, 300));
  Swal.close();
  await swalCustom.fire({
    html: `<div style="font-size:18px;"><b/>บันทึกข้อมูลสำเร็จ</div>`,
    icon: 'success',
    timer: 2000,
    confirmButtonText: "ปิด",
  });
  
  console.log('ปัญหาที่ 2 - เสร็จสิ้น');
  //  Swal.close();
  // emit('close-modal');
          //  if (refreshMemberData) {
          //   await refreshMemberData();
          // }
          // //   await nextTick();
          // // emit('update-state'); 
          //     //  setTimeout(() => {
          // swalCustom.fire({
          //   html: `<div style="font-size:18px;"><b/>บันทึกข้อมูลสำเร็จ</div>`,
          //   icon: 'success',
          //   timer: 2000,
          //   confirmButtonText: "ปิด"
          // }).then(() => {
          //   console.log('ปัญหาที่ 2')
          //   emit('close-modal'); 
          // }); 
          // // }, 100);
        } else {
          throw new Error('Failed to update member');
        }
      } catch (error) {
        console.error("Error updating member from CSG:", error);
        swalCustom.fire({
          text: "ทำรายการไม่สำเร็จ โปรดลองอีกครั้ง",
          icon: "warning",
          confirmButtonText: "ปิด",
        });
      }
    }
  }).catch((error) => {
    console.error("CSG: Error in selectConnectModalForm:", error);
  });
};
const convertThaiDateToISO = (thaiDate) => {
  const [day, month, yearBE] = thaiDate.split('-');
  
  const yearCE = parseInt(yearBE) - 543;

  const date = new Date(yearCE, parseInt(month) - 1, day);
  return date.toISOString(); 
}
//    const token = store.getters["userAuth/getToken"];
//   swalCustom.fire({
//       html: "ยืนยันบันทึกข้อมูลจาก ระบบเงินอุดหนุนเพื่อการเลี้ยงดูเด็กแรกเกิด (CSG)",
//       icon: "info",
//       showCancelButton: true,
//       reverseButtons: true,
//       confirmButtonText: 'ตกลง',
//       cancelButtonText: 'ยกเลิก',
//     }).then(async (result) => {
//       if (result.isConfirmed) {
//            try {
// const updates_father = {
//     national_id: csg_data.EQ_FATHER_IDCARD, 
//     title: csg_data.EQ_CODE_FATHER_PRENAME, 
//     name: (csg_data.EQ_FATHER_NAME || '').split(' ')[0], 
//     surname: (csg_data.EQ_FATHER_NAME || '').split(' ')[1],
//     nationality: csg_data.EQ_FATHER_NATIONALITY
// };

// let updatedFather = {
//     ...(props.infoData?.father || {}), 
//     ...updates_father 
// };

// const updates_mother = {
//     national_id: csg_data.EQ_MOTHER_IDCARD, 
//     title: csg_data.EQ_CODE_MOTHER_PRENAME, 
//     name: (csg_data.EQ_MOTHER_NAME || '').split(' ')[0], 
//     surname: (csg_data.EQ_MOTHER_NAME || '').split(' ')[1],
//     nationality: csg_data.EQ_MOTHER_NATIONALITY
// };
// let updatedMother = {
//     ...(props.infoData?.mother || {}), 
//     ...updates_mother 
// };

// console.log({"title":csg_data.EQC_CODE_PRENAME,
// "name":csg_data.EQC_FIRSTNAME,
// "surname":csg_data.EQC_LASTNAME,
// "birthdate":csg_data.EQC_BIRTH_DATE,
// "father":updatedFather,
// "mother":updatedMother})
//                 const config = {
//                     url: `${process.env.VUE_APP_BASE_API}member/${props.infoData._id}`,
//                     method: "PUT",
//                     headers:{
//                         Authorization: `Bearer ${token}`,
//                         "Content-Type": `application/json; charset=utf-8`,
//                     },
//                     data:{
//                         update:{
// "title":csg_data.EQC_CODE_PRENAME,
// "name":csg_data.EQC_FIRSTNAME,
// "surname":csg_data.EQC_LASTNAME,
// "birthdate":csg_data.EQC_BIRTH_DATE,
// "father":updatedFather,
// "mother":updatedMother
//                         }
//                     }
//                 }
//                  const res = await axios(config)
//              if (res.status === 200 || res.status === 201) {
//   // emit('close-modal');
//   emit('update-state');
//       swalCustom.fire({
//             html: `<div style="font-size:18px;"><b/>บันทึกข้อมูลสำเร็จ</div>`,
//             icon: 'success',
//             timer: 2000,
//         confirmButtonText: "ปิด"}).then(() => {
//             emit('close-modal'); // ✅ ปิด modal หลังจากแสดง success message
//           });
//             } else {
//           throw new Error('Failed to update member');
//         }
//       } else {
//           throw new Error('Failed to update member');
//         }
//     } catch (error) {
//       console.log("Error! ", error);
//       swalCustom.fire({
//         text: "ทำรายการไม่สำเร็จ โปรดลองอีกครั้ง",
//         icon: "warning",
//         confirmButtonText: "ปิด",
//       });
//        }
//     }
//   }).catch((error) => {
//     console.log("Error in selectConnectModalForm:", error);
//     swalCustom.fire({
//       text: "เกิดข้อผิดพลาด กรุณาลองอีกครั้ง",
//       icon: "error",
//       confirmButtonText: "ปิด",
//     });
//   });
// };
// const getFamAge = async (idcard) => {
//   if(idcard ==''){
//     return '-';
//   }
//   const token = store.getters["userAuth/getToken"];
//   const url = `${process.env.VUE_APP_BASE_API}member/getMemberSurveyById`;
//   const headers = {
//     Authorization: `Bearer ${token}`,
//     "Content-Type": `application/json; charset=utf-8`,
//   };
//   const res = await axios
//     .post(url, { member_nid: idcard }, { headers })
//     .then(function (res) { 
//       if(res.birthdate){
//        return rawDataToText(res.birthdate, "birthdate")
//       }else{
//       return '-';
//       }
//       })
//     .catch(() =>
//       Swal.fire({
//         icon: "warning",
//         text: "ระบบผิดพลาด",
//       })
//     );
// };
// const rawDataToText = (data, dataType) => {
//   switch (dataType) {
//     case "vital_status":
//       switch (data) {
//         case 1:
//           return "มีชีวิตอยู่";
//         case 0:
//           return "เสียชีวิต";
//         default:
//           console.log(
//             `สถานะการมีชีวิตต้องเป็นตัวเลข 1 หรือ 0 เท่านั้น แต่นี่เป็น ${data} (เป็น string ก็ไม่ได้)`
//           );
//           return "ข้อมูลไม่ตรง format";
//       }
//     case "birthdate":
//       return new Date(data).toLocaleDateString("th-TH");
//     default:
//       return data;
//   }
// };
// onMounted(() => {
//   const csg_data = {
// "EQ_GID_REGISTER":"พมจ.",
// "EQ_GID":"นครปฐม",
// "STATUS":"ได้รับเงิน",

// "EQC_CODE_PRENAME":"เด็กหญิง",
// "EQC_FIRSTNAME":"ณัฐนิชา",
// "EQC_LASTNAME":"ทด",
// "EQC_BIRTH_DATE":"2025-10-30T00:00:00.000Z",
// "EQ_FATHER_IDCARD":"1131313131315",
// "EQ_CODE_FATHER_PRENAME":"นาย",
// "EQ_FATHER_NAME":"ทนง ทด",
// "EQ_FATHER_NATIONALITY":"ไทย",
// "EQ_MOTHER_IDCARD":"1271271271123",
// "EQ_CODE_MOTHER_PRENAME":"นาง",
// "EQ_MOTHER_NAME":"ทนาง ทด",
// "EQ_MOTHER_NATIONALITY":"ไทย",
// "EQ_REGISTER_TYPE":"ผู้ปกครอง",

// "EQ_IDCARD":"2345678901234",
// "EQ_CODE_PRENAME":"ผู้ปกครอง",
// "EQ_FIRSTNAME":"ชื่อผู้ปกครอง",
// "EQ_LASTNAME":"สกุลผู้ปกครอง",
// "EQ_BIRTH_DATE":"2025-10-30T00:00:00.000Z",
// "EQ_NATIONALITY":"ไทย",
// "csg_status":"เด็กไม่อยู่ในพื้นที่"
// };
// let apiConfig = {
//                 url: `${process.env.VUE_APP_BASE_API}sol/csg/test`,
//                 method: "GET",
//                 headers: {
//                   Authorization: `Bearer ${token}`,
//                   "Content-Type": `application/json; charset=utf-8`,
//                 },
//                 // data: {
//                 //   // เลขบัตรประชาชน
//                 // }
//               };
//           if (apiConfig) {
//             promises.push(
//               axios(apiConfig)
//                 .then(response => ({ system, success: true, response }))
//                 .catch(error => ({ system, success: false, error }))
//             );
//           }
//         }
// let results = await Promise.all(promises);
// csg_data = results.data

//   infoToBeCompareCSG.value = [
//     {
//       field: "title",
//       label: "คำนำหน้า",
//       text: props.infoData?.title || '-',
//       csg_text: csg_data?.EQC_CODE_PRENAME || '-'
//     },
//     {
//       field: "name",
//       label: "ชื่อ",
//       text: props.infoData?.name || '-',
//       csg_text: csg_data?.EQC_FIRSTNAME || '-'
//     },
//     {
//       field: "surname",
//       label: "นามสกุล",
//       text: props.infoData?.surname || '-',
//       csg_text: csg_data?.EQC_LASTNAME || '-'
//     },
//     {
//       field: "birthdate",
//       label: "วัน/เดือน/ปีเกิด",
//       text: rawDataToText(props.infoData?.birthdate, "birthdate")|| '-',
//       csg_text: rawDataToText(csg_data?.EQC_BIRTH_DATE, "birthdate") || '-'
//     },
//    {
//       field: "father_idcard",
//       label: "เลขบัตรประชาชน (บิดา)",
//       text: props.infoData?.father?.national_id || '-',
//       csg_text: csg_data?.EQ_FATHER_IDCARD|| '-'
//     },
//     {
//       field: "father_name",
//       label: "ชื่อ-นามสกุล (บิดา)",
//       text: (props.infoData.father?.title || '') + ' ' + (props.infoData.father?.name || '') + ' ' + (props.infoData.father?.surname || ''),
//       csg_text: (csg_data?.EQ_CODE_FATHER_PRENAME|| '-') + ' ' + (csg_data?.EQ_FATHER_NAME|| '-')
//     },
//     {
//       field: "father_nationality",
//       label: "สัญชาติ (บิดา)",
//       text: props.infoData?.father?.nationality || '-',
//       csg_text: csg_data?.EQ_FATHER_NATIONALITY|| '-'
//     },
//     // {
//     //   field: "father_age",
//     //   label: "อายุ (บิดา)",
//     //   text: getFamAge(props.infoData.father?.national_id||''),
//     //   csg_text: getFamAge(props.infoData.father?.national_id||'')
//     // },
//    {
//       field: "mother_idcard",
//       label: "เลขบัตรประชาชน (มารดา)",
//       text: props?.infoData.mother?.national_id || '-',
//       csg_text: csg_data?.EQ_MOTHER_IDCARD || '-'
//     },
//     {
//       field: "mother_name",
//       label: "ชื่อ-นามสกุล (มารดา)",
//       text: (props.infoData?.mother?.title || '') + ' ' + (props.infoData?.mother?.name || '') + ' ' + (props.infoData.mother?.surname || ''),
//       csg_text: (csg_data?.EQ_CODE_MOTHER_PRENAME || '-')+ ' ' + (csg_data?.EQ_MOTHER_NAME || '-')
//     },
//     {
//       field: "mother_nationality",
//       label: "สัญชาติ (มารดา)",
//       text: props.infoData?.mother?.nationality || '-',
//       csg_text: csg_data?.EQ_MOTHER_NATIONALITY || '-'
//     },
//     {
//       field: "csg_status",
//       label: "สถานะเด็ก",
//       text: props.infoData?.csg_status || '-',
//       csg_text: csg_data?.csg_status || '-'
//     },
//     {
//       field: "STATUS",
//       label: "สถานะลงทะเบียน",
//       text: props.infoData?.csg_register_status || '-',
//       csg_text: csg_data?.STATUS || '-'
//     }
//     // {
//     //   field: "mother_age",
//     //   label: "อายุ (มารดา)",
//     //   text: getFamAge(props.infoData.mother?.national_id||''),
//     //   csg_text: getFamAge(props.infoData.mother?.national_id||'')
//     // },

//     // {
//     //   field: "birthdate",
//     //   label: "วัน/เดือน/ปีเกิด",
//     //   text: rawDataToText(props.infoData.birthdate, "birthdate"),
//     // }
//     // {
//     //   field: "address",
//     //   label: "ที่อยู่",
//     //   text:
//     //     `${props.infoData.hnum ? props.infoData.hnum + " " : ""}` +
//     //     `${props.infoData.moo ? "หมู่ " + props.infoData.moo : ""} ` +
//     //     `${props.infoData.village_name ? props.infoData.village_name : ""} ` +
//     //     `${props.infoData.soi ? "ซอย " + props.infoData.soi : ""} ` +
//     //     `${props.infoData.road ? "ถนน " + props.infoData.road : ""} ` +
//     //     `${
//     //       props.infoData.tumbol_name ? "ตำบล" + props.infoData.tumbol_name : ""
//     //     } ` +
//     //     `${
//     //       props.infoData.amphur_name ? "อำเภอ" + props.infoData.amphur_name : ""
//     //     } ` +
//     //     `${
//     //       props.infoData.province_name
//     //         ? "จังหวัด" + props.infoData.province_name
//     //         : ""
//     //     } ` +
//     //     `${props.infoData.postcode ? props.infoData.postcode : ""}`,
//     // },
//   ];
//   if(csg_data?.EQ_REGISTER_TYPE ==='ผู้ปกครอง' || props.infoData?.parent?.csg?.registrant_type  ==='ผู้ปกครอง'){
// infoToBeCompareCSG.value.push({
//       field: "EQ_IDCARD",
//       label: "บัตรประชาชน (ผู้ปกครอง)",
//       text: props.infoData?.parent?.national_id || '-',
//       csg_text: csg_data?.EQ_IDCARD || '-'
//     },{
//       field: "EQ_IDCARD",
//       label: "คำนำหน้า (ผู้ปกครอง)",
//       text: props.infoData?.parent?.title || '-',
//       csg_text: csg_data?.EQ_CODE_PRENAME || '-'
//     },{
//       field: "EQ_FIRSTNAME",
//       label: "ชื่อ (ผู้ปกครอง)",
//       text: props.infoData?.parent?.name || '-',
//       csg_text: csg_data?.EQ_FIRSTNAME || '-'
//     },{
//       field: "EQ_LASTNAME",
//       label: "สกุล (ผู้ปกครอง)",
//       text: props.infoData?.parent?.surname || '-',
//       csg_text: csg_data?.EQ_LASTNAME || '-'
//     },{
//       field: "EQ_BIRTH_DATE",
// label: "วัน/เดือน/ปีเกิด",
//       text: rawDataToText(props.infoData?.parent?.birthdate, "birthdate")|| '-',
//       csg_text:  rawDataToText(csg_data?.EQ_BIRTH_DATE, "birthdate")
//     },{
//       field: "EQ_NATIONALITY",
//       label: "สัญชาติ (ผู้ปกครอง)",
//       text: props.infoData?.parent?.nationality || '-',
//       csg_text: csg_data?.EQ_NATIONALITY || '-'
//     });
//   }
  
// });
</script>

<style>
#datatable-comparing {
  border-collapse: separate;
  border-spacing: 5px;
  width: 100%;
}
.label {
  vertical-align: text-top;
}
@media screen and (max-width: 372px) {
  /* 1. ซ่อน Header */
  #datatable-comparing thead {
    display: none;
  }

  /* 2. ทำให้แถวเป็นบล็อกแนวตั้ง */
  #datatable-comparing tr {
    display: block;
    margin-bottom: 10px;
    border: 1px solid #ccc;
  }

  /* 3. ทำให้เซลล์เป็นบล็อกแนวตั้ง และเพิ่ม Label */
  #datatable-comparing td {
    display: block;
    text-align: right;
    padding-left: 50%; /* เว้นที่ให้ Label */
    position: relative;
  }

  /* 4. ใช้ ::before เพื่อใส่ชื่อคอลัมน์เป็น Label */
  #datatable-comparing td::before {
    content: attr(data-label); /* ดึง Label จาก Attribute ใน HTML */
    position: absolute;
    left: 6px;
    font-weight: bold;
  }
}
</style>
